export default Object.freeze({
    INVITE_BY_EMAIL: 'invite_by_email',
    INVITE_BY_PHONE: 'invite_by_phone',
})
